// Trix leaves markup behind even when the editor reads empty
// ("<div><br></div>"), so presence checks must strip down to actual text
// first. Tags become spaces so "<div>a</div><div>b</div>" keeps a word
// boundary between lines.
export function plainTextFromTrix(html) {
  return (html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .trim();
}
